import { FC } from 'react';

import './Notice.css';

type Props = {
  title?: string | JSX.Element;
};

const Notice: FC<Props> = ({ title, children }) => {
  return (
    <div className="notice">
      {title && <div className="notice-text break-words">{title}</div>}
      {children}
    </div>
  );
};

export default Notice;
